import Home from '@/templates/pages/Home';
import GasStations from '@/templates/pages/GasStations';

const templatesList = {
  Homepage: Home,
  Cirrus_for_gas_stations: GasStations,
};

export default templatesList;
